var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComputer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 43,
  height: 35,
  viewBox: "0 0 43 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 6.62963C2 4.07276 4.07276 2 6.62963 2H36.446C39.0029 2 41.0756 4.07276 41.0756 6.62963V23.4208C41.0756 25.9777 39.0029 28.0504 36.446 28.0504H6.62963C4.07275 28.0504 2 25.9777 2 23.4208V6.62963Z",
  stroke: "#0F1E34",
  strokeWidth: 3.33333
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.895 32.609H28.9622",
  stroke: "#0F1E34",
  strokeWidth: 3.33333,
  strokeLinecap: "round"
})));
export { SvgComputer as ReactComponent };
export default __webpack_public_path__ + "static/media/computer.98cbcf1a.svg";